import * as React from 'react'

import { Box, Touchable } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Coffee, Moon, Salad, Star } from '@factorialco/f0-react/icons/app'

export type ExclusionType =
  | 'breakfastProvided'
  | 'lunchProvided'
  | 'dinnerProvided'
  | 'accommodationProvided'

const EXCLUSION_ICONS: Record<ExclusionType, typeof Coffee> = {
  breakfastProvided: Coffee,
  lunchProvided: Salad,
  dinnerProvided: Star,
  accommodationProvided: Moon,
}

interface ExclusionToggleButtonProps {
  type: ExclusionType
  isActive: boolean
  onToggle: () => void
}

const ExclusionToggleButton = ({ type, isActive, onToggle }: ExclusionToggleButtonProps) => {
  const IconComponent = EXCLUSION_ICONS[type]

  return (
    <Touchable onClick={onToggle}>
      <Box
        width="s140"
        height="s48"
        borderRadius={{ all: 'abs008' }}
        background={isActive ? 'viridian100' : 'white'}
        justifyContent="center"
        alignItems="center"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: isActive ? 'viridian600' : 'grey300',
          },
        }}
      >
        <F0Icon icon={IconComponent} size="md" color={isActive ? 'default' : 'secondary'} />
      </Box>
    </Touchable>
  )
}

export default ExclusionToggleButton
